import {Component, Input, OnInit} from '@angular/core';


@Component({
    selector: 'app-sidebar',
    templateUrl: 'sidebar.component.html',

})

export class SidebarComponent implements OnInit {

    @Input('permission') permission: string;

    constructor() {

    }

    ngOnInit() {
        // alert(this.permission);
    }

}
